import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Handles drag-to-reorder on the desktop Route Planner stop list.
// After a drag completes, it POSTes the new stop order to #reorder so
// the server persists the sequence numbers and the page re-renders.
export default class extends Controller {
  static targets = ["stopList"]
  static values = { repId: String, date: String, reorderUrl: String }

  connect() {
    if (this.hasStopListTarget) {
      this.#initDrag()
    }
  }

  disconnect() {
    this.#teardownDrag()
  }

  // ── Private ────────────────────────────────────────────────────────────────

  #dragItem = null
  #placeholder = null
  #listeners = []

  #initDrag() {
    const list = this.stopListTarget
    const onDragStart = (e) => {
      const row = e.target.closest("[data-stop-id]")
      if (!row) return
      this.#dragItem = row
      row.classList.add("opacity-50")
    }
    const onDragOver = (e) => {
      e.preventDefault()
      const target = e.target.closest("[data-stop-id]")
      if (!target || target === this.#dragItem) return
      const rect = target.getBoundingClientRect()
      const after = e.clientY > rect.top + rect.height / 2
      list.insertBefore(this.#dragItem, after ? target.nextSibling : target)
    }
    const onDragEnd = () => {
      if (!this.#dragItem) return
      this.#dragItem.classList.remove("opacity-50")
      this.#dragItem = null
      this.#submitReorder()
    }
    list.querySelectorAll("[data-stop-id]").forEach((row) => {
      row.setAttribute("draggable", "true")
    })
    list.addEventListener("dragstart", onDragStart)
    list.addEventListener("dragover", onDragOver)
    list.addEventListener("dragend", onDragEnd)
    this.#listeners = [
      [list, "dragstart", onDragStart],
      [list, "dragover", onDragOver],
      [list, "dragend", onDragEnd],
    ]
  }

  #teardownDrag() {
    this.#listeners.forEach(([el, event, fn]) =>
      el.removeEventListener(event, fn),
    )
    this.#listeners = []
  }

  async #submitReorder() {
    const list = this.stopListTarget
    const stopIds = Array.from(list.querySelectorAll("[data-stop-id]")).map(
      (row) => row.dataset.stopId,
    )
    await patch(this.reorderUrlValue, {
      body: JSON.stringify({ stop_ids: stopIds }),
      contentType: "application/json",
      responseKind: "json",
    })
  }
}
